<template>
  <v-container>
    <rest-resource-table
      label="Practicing Status Options"
      resource-name="practicingstatusoptions"
      resource-id-name="id"
      @saved="$store.dispatch('LOAD_CONFIG')"
      allow-new
      allow-delete
      edit-permission="editPracticingStatusOptions"
      :columns="columnHeaders"
    >
      <template v-slot:item.practicingStatusId="{ item }">
        <div>
          {{
            $store.getters.lookup(
              "PractisingStatus",
              item.practicingStatusId || 0
            ) || ""
          }}
        </div>
      </template>
      <template v-slot:form="{ item }">
        <div>
          <v-text-field
            label="System Name"
            :disabled="item.id"
            v-model="item.name"
          />
          <v-text-field label="Label (internal)" v-model="item.label" />
          <v-text-field
            label="Label (Public Register)"
            v-model="item.publicRegisterLabel"
          />
          <lookup-select
            lookup-name="PractisingStatus"
            label="Legacy Practicing Status"
            v-model="item.practicingStatusId"
            clearable
            persistent-hint
            hint="When auto-switching to this status, what should the legacy pracStatus field be changed to?"
          ></lookup-select>
          <!-- <v-checkbox label="inactive" v-model="item.inactive"></v-checkbox> -->
        </div>
      </template>
    </rest-resource-table>
  </v-container>
</template>

<script>
import restResourceTable from "@/components/lib/RestResourceTable.vue";
export default {
  name: "ScopesOfPracticeOptions",
  components: {
    restResourceTable
  },
  data() {
    return {
      columnHeaders: [
        {
          text: "id",
          value: "id"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Label",
          value: "label"
        },
        {
          text: "Public Register",
          value: "publicRegisterLabel"
        },
        {
          text: "Legacy Practicing Status",
          value: "practicingStatusId"
        }
      ]
    };
  }
};
</script>
